// extracted by mini-css-extract-plugin
export default {"wrapper":"EditAndDeleteAction_wrapper__K+pQW","deleteButton":"EditAndDeleteAction_deleteButton__Yn6Wl"};